var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","box-sizing":"border-box","width":"100%","height":"100%"}},[_c('div',[_c('CMenu',{attrs:{"active":"TXSearch"}})],1),_c('div',{staticClass:"view"})])}
var staticRenderFns = []

export { render, staticRenderFns }